export const setIsMobile = (isMobile) => {
  return {
    type: 'setIsMobile',
    isMobile
  }
};
